import { FileUpload, AndroidFile } from "@edp-models/file-upload.model";

export interface IFileUploadState {
    uploadedFile: FileUpload;
    androidFile: AndroidFile;
    uploadedFiles: FileUpload[];
}

export const initialFileUploadState: IFileUploadState = {
    uploadedFile: null,
    androidFile: null,
    uploadedFiles: []
};
